import { styles, variants, FormLayoutTheme } from '../FormLayoutStyles.css';
import { baseTheme } from './FormLayoutBaseTheme.css';
import { multiVariantStyles } from './FormLayoutVariants.css';

const FormLayoutStableTheme: FormLayoutTheme = {
  baseTheme,
  multiVariantStyles,
  variants,
  styles
};

/*******************
 * Exports
 *******************/

export { FormLayoutStableTheme };
